import { SupportFormValues } from "../../components/ui/modals/support.modal.component";
import { axiosClassic } from "../api";


class FormSubmissionService {
    private BASE_URL = "mail";
  
    async submitFeedback(data: SupportFormValues) {
      return await axiosClassic.post(`${this.BASE_URL}/support`, data);
    }

  }
  
export const formSubmissionService = new FormSubmissionService();